<template>
  <v-flex lg6>
    <div :style="{ 'padding-bottom': $vuetify.breakpoint.mdAndDown ? '32px' : ''}">
      <slot name="header" />
      <v-list>
        <v-list-tile v-for="(dish, index) in items" :key="dish.id" class="dishItem">
          <v-icon
            class="pr-2 pointer"
            small
            color="red"
            :style="{ visibility: (dish.edited) ? '' : 'hidden' }"
            @click="deleteDish(dish)"
          >close</v-icon>
          <v-flex xs3 md2 lg1 class="mr-3">
            <v-text-field
              :ref="`price-${index}`"
              v-model="dish.price"
              type="number"
              :label="$t('externalProvider.price')"
              :required="dish.edited"
              step="0.1"
              min="0.10"
              :rules="dish.edited ? [rules.required,
                                     rules.greaterThanZero,
                                     rules.numberLessThan(100)] : []"
              @input="onInputChange(dish)"
              @keyup.enter="focusNext(`price-${index + 1}`)"
              @change="$emit('dishesChange', items)"
            />
          </v-flex>
          <v-flex md8>
            <v-text-field
              :ref="`name-${index}`"
              v-model="dish.name"
              :label="$t('externalProvider.dishName')"
              :required="dish.edited"
              :rules="dish.edited ? [rules.required, rules.lengthNotGreaterThan] : []"
              @input="onInputChange(dish)"
              @keyup.enter="focusNext(`name-${index + 1}`)"
              @change="$emit('dishesChange', items)"
            />
          </v-flex>
        </v-list-tile>
      </v-list>
    </div>
  </v-flex>
</template>

<script>
import ValidationService from '@/services/ValidationService';

export default {
  name: 'CategoryDisplay',
  props: {
    dishes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const items = (this.dishes.length > 0 ? this.dishes : [{
      id: 0,
      name: null,
      price: null,
      edited: false,
    }]);

    return {
      items,
      rules: {
        required: ValidationService.rules.required(),
        greaterThanZero: ValidationService.rules.greaterThanZero(),
        numberLessThan: ValidationService.rules.numberLessThan(),
        lengthNotGreaterThan: ValidationService.rules.lengthNotGreaterThan('Value must not exceed 500 characters.', 500),
      },
    };
  },
  watch: {
    dishes(newV) {
      this.items = [...newV];
      if (this.items.length === 0) {
        this.items = [{
          id: 0,
          name: null,
          price: null,
          edited: false,
        }];
      }
    },
  },
  methods: {
    onInputChange(dish) {
      if (!dish.edited) {
        this.items.push({
          id: dish.id + 1,
          price: null,
          name: null,
          edited: false,
        });
        dish.edited = true; // eslint-disable-line no-param-reassign
      }
    },
    deleteDish(dish) {
      const index = this.dishes.indexOf(dish);
      this.dishes.splice(index, 1);
    },
    focusNext(ref) {
      const target = this.$refs[ref];
      if (target) {
        target[0].focus();
      }
    },
  },
};
</script>

<style scoped>
.dishItem >>> .list__tile {
  padding-left: 0 !important;
}

.pointer {
  cursor: pointer;
}
</style>
